export default "__VITE_ASSET__CjQ0hFXR__"